module.exports = __webpack_public_path__ + "img/email.ad20f163.svg";